import { Link } from 'react-router-dom';
import { buttonStyle } from '../styles';

export function NotFoundPage() {
  return (
    <main style={{ maxWidth: 480, margin: '4rem auto', padding: '0 1.5rem', textAlign: 'center' }}>
      <div className="num" style={{ fontSize: '3rem', fontWeight: 700, color: 'var(--brand)' }}>
        404
      </div>
      <h1 style={{ fontSize: '1.2rem', margin: '0.5rem 0 0.75rem' }}>Stránka sa nenašla</h1>
      <p style={{ color: 'var(--slate)', marginBottom: '1.5rem' }}>
        Skús vyhľadať firmu podľa IČO alebo názvu z domovskej stránky.
      </p>
      <Link to="/" style={{ ...buttonStyle, display: 'inline-block', textDecoration: 'none' }}>
        Späť na domovskú stránku
      </Link>
    </main>
  );
}
